import { useApiUtils } from '@core/util/apiUtils';
import empresaApi from 'app/services/api/empresaApi';
import empresaOnboardingApi from 'app/services/api/empresaOnboardngApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ApresentacaoOnboarding, DadosCadastraisOnboarding } from './components';
import CertificadoDigitalOnboarding from './components/CertificadoDigitalOnboarding';
import ContaBancariaOnboarding from './components/ContaBancariaOnboarding';
import FinalApresentacaoOnboarding from './components/FinalApresentacaoOnboarding';
import InformacoesFiscaisOnboarding from './components/InformacoesFiscaisOnboarding';
import LogomarcaOnboarding from './components/LogomarcaOnboarding';
import { OnboardingContext, OnboardingProvider } from './OnboardingContext';

const Onboarding = () => {
  const [etapa, setEtapa] = useContext(OnboardingContext).etapa;
  const [, setEmpresa] = useContext(GlobalContext).empresa;
  const [, setLoading] = useContext(OnboardingContext).loading;
  const [atualizarEtapa, setAtualizarEtapa] = useContext(OnboardingContext).atualizarEtapa;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useEffect(() => {
    fetchEmpresa();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (atualizarEtapa) {
      fetchEmpresa();
    }
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atualizarEtapa]);

  const fetchEmpresa = async () => {
    setLoading(true);
    try {
      const empresaId = getEmpresaContexto();
      if (empresaId) {
        // uuid format
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

        if (regexExp.test(empresaId)) {
          const response = await empresaApi.buscar(empresaId);

          const empresaResponse = { ...response.data, empresaId: response.data.id };
          setEmpresa(empresaResponse);
          fetchEtapa();
        }
      } else {
        setEtapa('INICIO');
      }
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchEtapa = async () => {
    const resp = await empresaOnboardingApi.findStatus();
    setEtapa(resp.data);
    setAtualizarEtapa(false);
  };

  return (
    <>
      {etapa === 'INICIO' && <ApresentacaoOnboarding />}
      {etapa === 'DADOS_CADASTRAIS' && <DadosCadastraisOnboarding />}
      {etapa === 'LOGOMARCA' && <LogomarcaOnboarding />}
      {etapa === 'INFORMACOES_FISCAIS' && <InformacoesFiscaisOnboarding />}
      {etapa === 'CONTA_BANCARIA' && <ContaBancariaOnboarding />}
      {etapa === 'CERTIFICADO_DIGITAL' && <CertificadoDigitalOnboarding />}
      {etapa === 'FINALIZADO' && <FinalApresentacaoOnboarding />}
    </>
  );
};

const OnboardingContainer = () => (
  <OnboardingProvider>
    <Onboarding />
  </OnboardingProvider>
);

export default OnboardingContainer;
